/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltypeupdate2Inputs */

const en_channeltypeupdate2 = /** @type {(inputs: Channeltypeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

const de_channeltypeupdate2 = /** @type {(inputs: Channeltypeupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuigkeit`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Channeltypeupdate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltypeupdate2 = /** @type {((inputs?: Channeltypeupdate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltypeupdate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltypeupdate2(inputs)
	return de_channeltypeupdate2(inputs)
});
export { channeltypeupdate2 as "channelTypeUpdate" }